import styled from 'styled-components';

const FormContainer = styled.div`
  padding: 2rem;
  background-color: #121212;
  color: white !important;
  max-width: 600px;
  margin: auto;
  border-radius: 8px;
`;

const Container = styled.div`
  font-family: Arial, sans-serif;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #333;
  border-radius: 4px;
  border-style: solid;
  border-width: thin;
  border-color: #696969;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 100%;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 10px;
  font-weight: bold;
  color: #ABABAB;
`;

const Select = styled.select`
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  font-size: 16px;
  border-radius: 5px;
  border: 1px solid #696969;
  background-color: #121212;
  color: #ABABAB;
  transition: border-color 0.3s ease;

  &:hover,
  &:focus {
    border-color: #48CDDB;
    outline: none;
  }
`;

const Input = styled.input`
  width: calc(100% - 20px);
  padding: 10px;
  margin-top: 10px;
  font-size: 16px;
  border-radius: 5px;
  border: 1px solid #696969;
  background-color: #121212;
  color: #ABABAB;
  margin-bottom: 10px;

  &:hover,
  &:focus {
    border-color: #48CDDB;
    outline: none;
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 10px;
  font-size: 16px;
  color: #000000;
  background-color: #48CDDB;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #48CDDB;
  }
`;

const FooterContainer = styled.div`
  text-align: center;
  padding: 1rem;
  background: #222;
  color: #fff;
  margin-top: 2rem;
`;
const HeaderContainer = styled.div`
  background: #222;
  color: #fff;
  padding: 1rem;
  text-align: center;
  font-size: 1.5rem;
`;

const CheckboxContainer = styled.div`
  padding: 1.5rem;
  background-color: #f9f9f9; /* Light grey background */
  border: 1px solid #e0e0e0; /* Subtle border */
  border-radius: 10px; /* Rounded edges */
  max-width: 600px;
  margin: 20px auto;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Subtle shadow */
  font-family: Arial, sans-serif;
`;

// Title styling
const Title = styled.h3`
  text-align: center;
  margin-bottom: 1.5rem;
  color: #333333; /* Dark grey */
`;

// Section title styling
const SectionTitle = styled.h4`
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  color: #555555; /* Medium grey */
`;

// Checkbox label styling
const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
  font-size: 1rem;
  padding-right: 10px;
  padding-left: 10px;
  color: #333333; /* Dark grey text */
  cursor: pointer;
`;

// Styled checkbox input
const StyledCheckbox = styled.input`
  margin-right: 10px;
  width: 20px;
  height: 20px;
  accent-color: green;
}

`;

// Group container for checkbox rows
const CheckboxGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`;

// Textbox for "Other" input
const OtherInput = styled.input`
  width: calc(100% - 20px);
  padding: 10px;
  margin-top: 10px;
  font-size: 16px;
  border-radius: 5px;
  border: 1px solid #696969;
  background-color: #ffffff;
  color: black;
  margin-bottom: 10px;
`;

export { FormContainer, Container, Label, Select, Input, Button, FooterContainer, HeaderContainer, 
  CheckboxContainer, Title,SectionTitle, CheckboxLabel, StyledCheckbox,CheckboxGroup, OtherInput
};